import React, { useEffect, useRef, useState } from 'react';
import {
	XEditButtonIcon,
	XTag,
	XThemeContainer,
	XThemeFilterButton,
	XThemeFilterCards,
	XThemeFilterCircleButton,
	XThemeInputText,
	XThemeLogsTags,
	XThemeTable,
	XThemeTag,
} from '../../styles/GlobalThemeStyle';
import { Row, Col, Space, Popover, Tooltip, Button, Grid } from 'antd';
import Header from '../../components/Header/Header';
import HeaderFile from '../../components/Header/HeaderFile';
import { PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import {
	XThemeBulkTags,
	XThemeEmptySimulateEhr,
	XThemeStartCancelBTN,
} from './SimulateEhrStyle';
import { Link, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import {
	getSimulateEhrListApi,
	getSimulateEhrListReset,
} from '../../actions/getSimulateEhrListAction';
import moment from 'moment';
import { checkModulePermissions } from '../../utils/helper';
import {
	XTheme2InnerCard,
	XTheme2Para1,
	XThemeDashboardLottieCard,
} from '../Dashboard/DashboardStyleCQ';
import DashboardJson from '../../json/Reclaim.json';
import {
	XTheme2Button,
	XTheme2InputText,
	XTheme2MainTitle,
	XTheme2Table,
} from '../../styles/GlobalThemeStyleCQ';

const SimulateEhr = (props) => {
	const {
		getSimulateEhrListState = { apiState: '', data: [] },
		getSimulateEhrList,
	} = props;
	const [dataSource, setDataSource] = useState([]);
	const [totalRecords, setTotalRecords] = useState(0);
	const [tableLoading, setTableLoading] = useState(false);
	const [filters, setFilters] = useState({
		search: '',
		page: 1,
		limit: 10,
		sort: 'createdAt',
		sortDirection: 'descend',
	});
	const navigate = useNavigate();

	const columns = [
		{
			title: 'Simulation Name',
			dataIndex: 'simulationName',
			width: '20%',
			// render: (text, record) => (
			// 	<Link to={`/simulate-ehr-details/${record.key}`}>{record.name}</Link>
			// ),
		},
		{
			title: 'Excel Name',
			dataIndex: 'excelName',
		},
		{
			title: 'No. of Cases',
			dataIndex: 'NoOfCases',
			align: 'center',
		},
		{
			title: 'Status',
			dataIndex: 'status',
			align: 'center',
			render: (status) => {
				const statusClass = status.toLowerCase();
				const formattedStatus = status
					.split('_')
					.map(
						(word) =>
							word.charAt(0).toUpperCase() +
							word.slice(1).toLowerCase(),
					)
					.join(' ');

				return (
					<XThemeBulkTags className={statusClass}>
						{formattedStatus}
					</XThemeBulkTags>
				);
			},
		},
		{
			title: 'Created On',
			dataIndex: 'createdOn',
			align: 'center',
			render: (date) => (
				<div className="showDate">
					{moment(date).format('DD-MM-YYYY')}
				</div>
			),
		},
		// {
		// 	title: 'Action',
		// 	dataIndex: 'action',
		// 	align: 'center',
		// 	render: (_, record) => (
		// 		<Space>
		// 			<Link to={`/simulate-ehr-details/${record.key}`}>
		// 				<XEditButtonIcon size="small" type="text">
		// 					<img src="./images/view-icon.svg" alt="" />
		// 				</XEditButtonIcon>
		// 			</Link>
		// 		</Space>
		// 	),
		// },
	];

	useEffect(() => {
		if (getSimulateEhrListState.apiState === 'success') {
			setTableLoading(false);
			if (
				getSimulateEhrListState.data?.data?.simulateEhrList?.length > 0
			) {
				const updatedData = [];
				setTotalRecords(
					getSimulateEhrListState.data.data.pagination.total,
				);
				getSimulateEhrListState.data.data.simulateEhrList.map(
					(item) => {
						const excelName = item.excel_url
							? decodeURIComponent(
									item.excel_url.split('/').pop(),
							  )
							: '-';
						updatedData.push({
							key: item._id,
							name: item.simulate_ehr_name,
							simulationName: item.simulate_ehr_name,
							excelName: excelName,
							NoOfCases: item?.total_cases || '-',
							status: item.status,
							createdOn: item.createdAt,
						});
					},
				);
				setDataSource(updatedData);
			} else {
				setDataSource([]);
				setTotalRecords(0);
			}
		}
	}, [getSimulateEhrListState]);

	useEffect(() => {
		getSimulateEhrList(filters);
	}, [filters]);

	const handleTableChange = (pagination, filters, sorter) => {
		setTableLoading(true);
		setFilters({
			...filters,
			page: pagination.current,
			limit: pagination.pageSize,
		});
	};

	const handleSearch = (value) => {
		setTableLoading(true);
		if (value === '') {
			setFilters({
				...filters,
				search: '',
				page: 1,
			});
		} else {
			setFilters({
				...filters,
				search: value,
				page: 1,
			});
		}
	};
	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;
	return (
		<>
			<Col lg={24} xl={24} xs={0} md={0}>
				<Header headerTag="Simulate EHR" />
			</Col>
			<Col lg={0} xl={0} xs={24} md={24}>
				<HeaderFile />
			</Col>
			<XThemeContainer fluid>
				<Row gutter={[15, 15]} className="align-items-center mb-4">
					<Col
						xs={24}
						sm={24}
						md={12}
						lg={12}
						xl={12}
						className="text-center text-md-start"
					>
						<XTheme2MainTitle className="mb-2">
							Simulate EHR
						</XTheme2MainTitle>
						<XTheme2Para1>
							Simulate and manage EHR cases within the designated
							work loads.
						</XTheme2Para1>
					</Col>
					<Col
						xs={24}
						sm={24}
						md={12}
						lg={12}
						xl={12}
						className="text-center text-md-end"
					>
						{isMobile ? (
							<XTheme2Button
								shape="circle"
								size="large"
								className="noBackground borderColor"
								onClick={() => navigate('/create-simulation')}
								icon={<PlusOutlined />}
							/>
						) : (
							<Link to="/create-simulation">
								<XTheme2Button
									size="large"
									icon={<PlusOutlined />}
								>
									Add Simulation
								</XTheme2Button>
							</Link>
						)}
					</Col>
				</Row>

				{dataSource.length === 0 &&
				getSimulateEhrListState.apiState === 'success' ? (
					<XThemeEmptySimulateEhr
						image="/images/empty.svg"
						description={
							filters.search
								? 'No simulations found matching your search'
								: 'No simulations found. Create your first simulation to get started!'
						}
					>
						<Link to="/create-simulation">
							<XThemeFilterButton
								className="backgroundRevers mt-3"
								icon={<PlusCircleFilled />}
							>
								Add Simulation
							</XThemeFilterButton>
						</Link>
					</XThemeEmptySimulateEhr>
				) : (
					<>
						<XTheme2InnerCard
							className="mb-3 withBackground"
							bodyStyle={{ padding: '20px 0px' }}
						>
							<div className="smallTopBottomPadding mb-3 px-4">
								<Row
									gutter={(15, 15)}
									className="align-items-center"
								>
									<Col
										xs={24}
										sm={24}
										md={12}
										lg={12}
										className="mb-3 mb-md-0"
									>
										<h1
											className="cardTitle mb-0"
											style={{ fontSize: '18px' }}
										>
											Total {totalRecords} Simulations
										</h1>
									</Col>
									<Col
										xs={24}
										sm={16}
										md={12}
										lg={12}
										className="mb-3 mb-sm-0 text-end"
									>
										<Space>
											<XThemeInputText
												size="large"
												allowClear
												placeholder="Search for Simulations"
												defaultValue={
													filters.search || null
												}
												onChange={(e) =>
													handleSearch(e.target.value)
												}
												onKeyDown={(e) => {
													if (
														e.key === 'Enter' &&
														filters.search
													) {
														getSimulateEhrList({
															...filters,
															search: filters.search,
														});
													}
												}}
											/>
											<XTheme2Button
												onClick={() => {
													if (filters.search) {
														getSimulateEhrList({
															...filters,
															search: filters.search,
														});
													}
												}}
											>
												Search
											</XTheme2Button>
										</Space>
									</Col>
								</Row>
							</div>
							<XTheme2Table
								columns={columns}
								dataSource={dataSource}
								scroll={{ x: 991 }}
								className=""
								loading={
									tableLoading ||
									getSimulateEhrListState.apiState ===
										'loading'
								}
								onChange={handleTableChange}
								pagination={{
									total: totalRecords,
									pageSize: filters.limit,
									current: filters.page,
									showSizeChanger: true,
								}}
							/>
						</XTheme2InnerCard>
					</>
				)}
			</XThemeContainer>
		</>
	);
};

const mapStateToProps = (state) => ({
	getSimulateEhrListState: state.getSimulateEhrList,
});

const mapDispatchToProps = (dispatch) => ({
	getSimulateEhrList: (data) => dispatch(getSimulateEhrListApi(data)),
	getSimulateEhrListReset: () => dispatch(getSimulateEhrListReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SimulateEhr);
